'use client';

import { useEffect } from 'react';
import { useTheme } from 'next-themes';

export const ThemeUpdater = () => {
    const { theme } = useTheme();

    useEffect(() => {
        const root = document.documentElement;
        const isDark = theme === 'dark';

        if (isDark) {
            root.style.setProperty('--color-bg-primary', '#111827');
            root.style.setProperty('--color-bg-secondary', '#1f2937');
            root.style.setProperty('--color-text-primary', '#f9fafb');
            root.style.setProperty('--color-text-secondary', '#d1d5db');
        } else {
            root.style.setProperty('--color-bg-primary', 'white');
            root.style.setProperty('--color-bg-secondary', '#f9fafb');
            root.style.setProperty('--color-text-primary', '#111827');
            root.style.setProperty('--color-text-secondary', '#4b5563');
        }
    }, [theme]);

    return null;
};
